import { extendTheme, ThemeConfig } from "@chakra-ui/react";
import semanticTokens from "./semanticTokens";
import Button from "./buttons";
import fonts from "./fonts";
import textStyles from "./text";
import styles from "./styles";
import customIcons from "./icons";
import Table from "./table";
import Heading from "./heading";

const config: ThemeConfig = {
  initialColorMode: "light", // or "dark" if you want dark by default
  useSystemColorMode: false // don't follow system setting
};
export const overrides = {
  config,
  styles,
  semanticTokens,
  textStyles,
  fonts,
  icons: {
    ...customIcons
  },

  components: {
    Button,
    Table,
    Heading

    // Other components go here
  }
};

export default extendTheme(overrides);
